import PromptList from "../views/aiManage/promptList";
import DrawTaskList from "../views/aiManage/drawTaskList";
import AiLableBuilder from "../views/aiManage/aiLableBuilder";
import DrawTool from "../views/aiManage/drawTool";
import DrawRecord from "../views/aiManage/drawRecord";

import Main from "../views/main";

const Administrators = {
  path: "/prompt-list",
  component: Main,
  title: "AI管理",
  icon: "el-icon-s-custom",
  meta: { keepAlive: true },
  children: [
    {
      path: "/prompt-list",
      component: PromptList,
      name: "promptList",
      title: "提词列表",
      meta: { title: "提词列表", keepAlive: true },
    },
    {
      path: "/draw-task-list",
      component: DrawTaskList,
      name: "drawTaskList",
      title: "绘画任务列表",
      meta: { title: "绘画任务列表", keepAlive: true },
    },
    {
      path: "/draw-record",
      component: DrawRecord,
      name: "drawRecord",
      title: "绘画记录",
      meta: { title: "绘画记录", keepAlive: true },
    },
    {
      path: "/ai-lable-builder",
      component: AiLableBuilder,
      name: "aiLableBuilder",
      title: "AI标签生成器",
      meta: { title: "AI标签生成器", keepAlive: true },
    },
    {
      path: "/draw-tool",
      component: DrawTool,
      name: "drawTool",
      title: "绘画工具",
      meta: { title: "绘画工具", keepAlive: true },
    },
  ],
};
export default Administrators;
